// extracted by mini-css-extract-plugin
export default {"container":"cchsglm0k","textHolder":"ck46s187o","title":"crknfg462","desc":"ch7yt14ts"};